export default "__VITE_ASSET__LHIR1GNF__"